"use strict";
/**
 * ************************************
 *
 * @module next-persist
 * @author most-js
 * @description module that contains function to get state from localStorage
 *
 * ************************************
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalStore = void 0;
function getLocalStore(key, state) {
    // if application is running client-side, localStorage is accessible
    if (typeof window !== 'undefined') {
        var clientState = localStorage.getItem(key);
        // if localStorage contains the key user queries,
        // parse the data and return an updated state object
        if (clientState) {
            var parsedClientState = JSON.parse(clientState);
            return __assign(__assign({}, state), parsedClientState);
        }
    }
    // if localStorage doesn't contain the key user queries or application isn't running client-side,
    // return original state that was passed in
    return state;
}
exports.getLocalStore = getLocalStore;
